export default () => ({
  root: {
    marginTop: '1.2rem',
  },
});
